import { render, staticRenderFns } from "./PlantsFormPage.vue?vue&type=template&id=03c49e36&scoped=true&"
import script from "./PlantsFormPage.vue?vue&type=script&lang=js&"
export * from "./PlantsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./PlantsFormPage.vue?vue&type=style&index=0&id=03c49e36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c49e36",
  null
  
)

export default component.exports